import { z } from "zod";

export const GeoCountrySchema = z.object({
  code: z.string(),
  name: z.string(),
});

export const GeoResultDetailSchema = z.object({
  iso_code: z.string().optional(),
  names: z.object({
    en: z.string().optional(),
  }).optional(),
});

export const GeoResultSchema = z.object({
  lat: z.number().optional(),
  lng: z.number().optional(),
  city: z.string().optional(),
  region: z.string().optional(),
  country: z.string().optional(),
  timezone: z.string().optional(),
  countryDetail: GeoResultDetailSchema.optional().nullable(),
  source: z.string(),
});

export const GeoRequestSchema = z.object({
  ip: z.string().optional(),
});

export const GeoResponseSchema = z.object({
  ip: z.string().optional().nullable(),
  geo: GeoResultSchema.optional().nullable(),
});

export type GeoCountryDto = z.infer<typeof GeoCountrySchema>;
export type GeoResultDto = z.infer<typeof GeoResultSchema>;
export type GeoRequestDto = z.infer<typeof GeoRequestSchema>;
export type GeoResponseDto = z.infer<typeof GeoResponseSchema>;
